import React from 'react';
import { useDashboardLocaleStore } from '@/presentation/dashboard/useDashboardLocaleStore';
import { translate } from '@/i18n/dictionary';

/**
 * i18n gọn cho toàn app (locale dùng chung với dashboard shell).
 *
 * @example
 * const { t, locale } = useAppTranslation();
 * setError(e.message || t('errors.loadSettings'));
 * t('settings.themeApplied', { theme: 'dark' })
 */
export function useAppTranslation() {
  const locale = useDashboardLocaleStore((s) => s.locale);
  const setLocale = useDashboardLocaleStore((s) => s.setLocale);
  const t = React.useCallback(
    (key, vars) => translate(locale, key, vars),
    [locale],
  );
  return { locale, setLocale, t };
}
